<template>

    <footer class="footer" style="padding-top: 23px;" >
        <div class="container ">
            <div class="row">
                <div class="col-lg-4">
                    <h5 class="call-us" style="font-size: 17px;"> Questions?<br> <span class="colorg"> <span class="colorg">
              Call +91 79 9444 1444
              <span style="padding-left: 5px; padding-right: 10px; color: white">
                |
              </span>   </span>    <a href="https://www.facebook.com/palaxicinemas" style="color: #f89723 !important;"><span style="padding-left: 5px; padding-right: 10px">
                <i class="fa fa-facebook-square" aria-hidden="true"></i>
              </span></a>
              <a href="https://www.instagram.com/palaxi_cinemas/" style="color: #f89723 !important;"><i class="fa fa-instagram" aria-hidden="true"></i></a>

                        </span></h5>
                    <!-- <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,</p> -->

                    <!-- end language -->
                </div>
                <!-- end col-4 -->

                <!-- end col-4 -->
            </div>
            <!-- end row -->
        </div>


        <div class="container tepat" style="padding-top: 20px !important;">
            <div class="row">
               
                <div class="col-lg-4" style="padding-bottom: 10px;">
                    <div class="pb-15" style="padding-top: 5px; font-size: 12px;">
                        Download App
                    </div>


                    <span>
                      <a href="https://apps.apple.com/in/app/hilite-mall/id1665021598">
                      <img :src="imgPath+'images/applestore_tcm295-131980.svg'" alt="" style="width: 22%;padding-right: 20px;"></a>
                    </span>

                    <span><a href="https://play.google.com/store/apps/details?id=io.proximety.hilitemall"><img :src="imgPath+'images/googlestore_tcm295-131981.svg'" alt="" style="width: 22%;padding-right: 20px;"></a> 
                    </span>


                </div>
                <br>

                <div class="col-6" >

                    <div class="pb-20" style="font-size: 12px;">Technology Partners </div>

                    <div>
                        <carousel
            :dots="false"
            :autoplay="true"
            :loop="true"
            :items="1"
            :nav="false"
            :margin="20"
            :rewind="true"
            :autoplayTimeout="2000"
            :smartSpeed="800"
            :responsiveClass="true"
            :autoHeight="true"
            :responsive="{
              0: { items: 3 },
              600: { items: 3 },
              1024: {
                items: 4,
              },
              1366: {
                items: 4,
              },
            }"
          >
          <img :src="imgPath+'images/qb.png'" alt="1000X1000" />

          <img :src="imgPath+'images/im.png'" alt="1000X1000" />

            <img :src="imgPath+'images/b.png'" alt="1000X1000" />
            <img :src="imgPath+'images/tech-partner-dolby_tcm307-131974.png'" alt="" />
            <img
            :src="imgPath+'images/screenX-thumb-NEW_tcm307-133267.png'"
              alt="1000X1000"
            />

            <img
            :src="imgPath+'images/tech-partner-dolby_tcm307-131974.png'"
              alt="1000X1000"
            />
            <img :src="imgPath + 'images/mv.png'" alt="1000X1000" />
            <img :src="imgPath+'images/b.png'" alt="1000X1000" />
            <img :src="imgPath+'images/qb.png'" alt="1000X1000" />
            <img
            :src="imgPath+'images/tech-partner-dolby_tcm307-131974.png'"
              alt="1000X1000"
            />

            <img
            :src="imgPath+'images/screenX-thumb-NEW_tcm307-133267.png'"
              alt="1000X1000"
            />
            <img
            :src="imgPath+'images/tech-partner-dolby_tcm307-131974.png'"
              alt="1000X1000"
            />
            <img :src="imgPath + 'images/mv.png'" alt="1000X1000" />
          </carousel>


                    </div>


                </div>
                
                <div class="col-6">

                    <div class="pb-20" style="font-size: 12px;">
                        Partners </div>


                    <div>
                        <carousel
            :dots="false"
            :autoplay="true"
            :loop="true"
            :items="1"
            :nav="false"
            :margin="20"
            :rewind="true"
            :autoplayTimeout="2000"
            :smartSpeed="800"
            :responsiveClass="true"
            :autoHeight="true"
            :responsive="{
              0: { items: 3 },
              600: { items: 3 },
              1024: {
                items: 4,
              },
              1366: {
                items: 4,
              },
            }"
          >
            <img :src="imgPath+'images/hi.png'" alt="1000X1000" />

            <img :src="imgPath+'images/hug.png'" alt="" />

            <img :src="imgPath+'images/6t6.png'" alt="" />

            <img :src="imgPath+'images/hi.png'" alt="1000X1000" />

            <img :src="imgPath+'images/hug.png'" alt="" />
          </carousel>


                    </div>


                </div>
                
            </div>
        </div>

        <!-- end container -->
        <div class="bottom-bar" style="margin-bottom: 0px; margin-top: 15px; padding-top: 22px;">
            <div class="container text-center"> <span class="fullwid">2024 © Palaxi Cinemas | Ticketing Backend
                    Powered By Movieclicks</span> </div>
            <!-- end container -->
        </div>
        <!-- end bottom-bar -->
    </footer>

</template>
<script>
import carousel from "vue-owl-carousel/src/Carousel";

export default {
  components: {
    carousel,
  },
  data() {
    return {
      imgPath: process.env.BASE_URL,

    }
  },

};
</script>